import { render, staticRenderFns } from "./FileManagerStorage.vue?vue&type=template&id=5dfc7f4c&"
import script from "./FileManagerStorage.vue?vue&type=script&lang=js&"
export * from "./FileManagerStorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports